var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { postJson } from '@rad/utility/http';
import { requireToken } from '../../../utility/general';
import CModal from '../modal';
import CInput from '../input';
const digitsOnly = (s) => s.replace(/\D/g, '');
export default (props) => {
    const token = requireToken('merchant');
    const [firstname, setFirstname] = React.useState('');
    const [lastname, setLastname] = React.useState('');
    const [phone, setPhone] = React.useState(props.prefilledPhone);
    const [errors, setErrors] = React.useState(null);
    const [submitting, setSubmitting] = React.useState(false);
    React.useEffect(() => {
        if (props.visible) {
            setFirstname('');
            setLastname('');
            setPhone(props.prefilledPhone);
            setErrors(null);
            setSubmitting(false);
        }
    }, [props.visible, props.prefilledPhone]);
    const errorMap = (errors || []).reduce((agg, x) => (Object.assign(Object.assign({}, agg), { [x.field]: x.message })), {});
    const canSubmit = firstname.trim().length > 0 && lastname.trim().length > 0 && digitsOnly(phone).length >= 10;
    const handleSubmit = (done) => __awaiter(void 0, void 0, void 0, function* () {
        if (!canSubmit) {
            done();
            return;
        }
        setSubmitting(true);
        setErrors(null);
        try {
            const result = yield postJson(`/merchants/${token.merchant.id}/clients/create`, {
                'client_firstname': firstname.trim(),
                'client_lastname': lastname.trim(),
                'client_no_address': true,
                'client_address': '-',
                'client_address2': '',
                'client_city': '-',
                'client_state': '--',
                'client_zip': '-',
                'client_contacts': [
                    { 'kind': 'phone', 'subkind': 'mobile', 'value': digitsOnly(phone) },
                ],
                'client_notes': [],
                'client_notes_new': [],
            })((x) => x, (m) => (Object.assign(Object.assign({}, m), { 400: (r) => __awaiter(void 0, void 0, void 0, function* () { throw r; }), 422: (r) => __awaiter(void 0, void 0, void 0, function* () { throw r; }), 500: (r) => __awaiter(void 0, void 0, void 0, function* () { throw r; }) })));
            props.onCreated({ 'id': result.id, 'firstname': firstname.trim(), 'lastname': lastname.trim() });
        }
        catch (r) {
            try {
                setErrors(yield r.json());
            }
            catch (_a) {
                setErrors([{ 'field': '_', 'message': 'Could not create customer. Try again.' }]);
            }
        }
        finally {
            setSubmitting(false);
            done();
        }
    });
    return _jsxs(CModal, { visible: props.visible, title: "Add Customer", onClose: props.onClose, onSubmit: handleSubmit, action: "Add Customer", sm: true, disabled: !canSubmit || submitting, children: [_jsx("p", { className: "text-muted small mb-3", children: "Save this number as a new customer. You can fill in address, vehicles, and notes from their customer page later." }), _jsx(CInput, { type: "text", value: firstname, onChange: setFirstname, required: true, error: errorMap['client_firstname'], children: "First Name" }), _jsx(CInput, { type: "text", value: lastname, onChange: setLastname, required: true, error: errorMap['client_lastname'], children: "Last Name" }), _jsx(CInput, { type: "tel", value: phone, onChange: setPhone, required: true, error: errorMap['client_contacts'], children: "Mobile Phone" }), !!errorMap['_'] && _jsx("div", { className: "alert alert-danger small mb-0", children: errorMap['_'] })] });
};
